<template>
    <div id="app-container">
        <div class="App iframe-bank-invoice-payment-group">
            <div>
                <span class="SecurityEnvironmentIcon">
                    <i class="icon-lock"></i>
                    <span class="payment-environment-icon-text">Ambiente Seguro</span>
                </span>
                <div class="CardForm">
                    <div class="BillingAddress BillingAddress-BRA clearfix">
                        <h3 data-bind="text: localizedLabel">Boleto bancário</h3>
                        <p class="payment-description" data-bind="text: localizedDescription">O Boleto bancário será exibido após a confirmação da compra e poderá ser impresso para pagamento em qualquer agência bancária, ou ter o número anotado para pagamento pelo telefone ou internet.</p>
                        <p class=" input text required mask">
                            <label class="FormFieldLabel " for="holder-document-0">CPF do titular</label>
                            <input id="holder-document-0" class="input-small  " type="tel" placeholder="999.999.999-99" v-model="paymentBankInvoice.document">
                        </p>
                        <div>
                            <h5>Endereço de cobrança</h5>
                            <p class="payment-billing-address-country input one-delivery-country">País: BRA</p>
                            <div class="CountrySelector--all-countries">
                                <p class="payment-billing-address-country input text">
                                    <label class="FormFieldLabel " for="payment-billing-address-all-countries-0">País<span class="item-required">&nbsp;*</span></label>
                                    <select class="input-medium" id="payment-billing-address-all-countries-0" v-model="paymentBankInvoice.addressCountry">
                                        <option></option>
                                        <option v-for="(country, index) in countries" :key="index" v-bind:value="country.code">{{country.name}}</option>
                                    </select>
                                </p>
                            </div>
                            <div class="AddressForm">
                                <div class="PostalCode input text">
                                    <label class="FormFieldLabel " for="payment-billing-address-postalCode-0">CEP<span class="item-required">&nbsp;*</span></label>
                                    <input class="payment-billing-address-postalCode input-small " autocomplete="nope" id="payment-billing-address-postalCode-0" type="tel" v-model="paymentBankInvoice.postalCode" v-on:keyup="searchCep">
                                </div>
                                <p class="AddressField payment-billing-address-street input text ">
                                    <label class="FormFieldLabel " for="payment-billing-address-street-0">Endereço<span class="item-required">&nbsp;*</span></label>
                                    <input autocomplete="nope" class="payment-billing-address-street input-xlarge  " id="payment-billing-address-street-0" type="text" v-model="paymentBankInvoice.addressStreet">
                                </p>
                                <p class="AddressField payment-billing-address-number input text ">
                                    <label class="FormFieldLabel " for="payment-billing-address-number-0">Número<span class="item-required">&nbsp;*</span></label>
                                    <input autocomplete="nope" class="payment-billing-address-number input-mini  " id="payment-billing-address-number-0" type="text" v-model="paymentBankInvoice.addressNumber">
                                </p>
                                <p class="AddressField payment-billing-address-complement input text ">
                                    <label class="FormFieldLabel " for="payment-billing-address-complement-0">Complemento e referência</label>
                                    <input autocomplete="nope" class="payment-billing-address-complement input-large  " id="payment-billing-address-complement-0" type="text" placeholder="Opcional" v-model="paymentBankInvoice.addressComplement">
                                </p>
                                <p class="AddressField payment-billing-address-neighborhood input text ">
                                    <label class="FormFieldLabel " for="payment-billing-address-neighborhood-0">Bairro<span class="item-required">&nbsp;*</span></label>
                                    <input autocomplete="nope" class="payment-billing-address-neighborhood input-large  " id="payment-billing-address-neighborhood-0" type="text" v-model="paymentBankInvoice.addressNeighborhood">
                                </p>
                                <p class="AddressField payment-billing-address-city input text ">
                                    <label class="FormFieldLabel " for="payment-billing-address-city-0">Cidade<span class="item-required">&nbsp;*</span></label>
                                    <input autocomplete="nope" class="payment-billing-address-city input-large  " id="payment-billing-address-city-0" type="text" v-model="paymentBankInvoice.addressCity">
                                </p>
                                <p class="AddressField payment-billing-address-state input text ">
                                    <label class="FormFieldLabel " for="payment-billing-address-state-0">Estado<span class="item-required">&nbsp;*</span></label>
                                    <select autocomplete="nope" class="payment-billing-address-state input-mini  " id="payment-billing-address-state-0" v-model="paymentBankInvoice.addressState">
                                        <option value="">UF</option>
                                        <option v-for="(state, index) in states" :key="index" v-bind:value="state.code">{{state.name}}</option>
                                    </select>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<style scoped src="@/assets/css/checkout-paymentcreditcard.module.css"></style>

<script>

    import { cepApi } from '@/services/api/cepApi.js'

    export default {
        name: 'payment-bankinvoice',
        data: () => ({
            paymentBankInvoice: {
                document: '',
                postalCode: '',
                addressCountry: 'BRA',
                addressStreet: '',
                addressNeighborhood: '',
                addressNumber: '',
                addressCity: '',
                addressState: '',
            },
            countries: [
                { code: 'BRA', name: 'Brasil' }
            ],
            states: [
                { code: 'AC', name: 'AC' },
                { code: 'AL', name: 'AL' },
                { code: 'AM', name: 'AM' },
                { code: 'AP', name: 'AP' },
                { code: 'BA', name: 'BA' },
                { code: 'CE', name: 'CE' },
                { code: 'DF', name: 'DF' },
                { code: 'ES', name: 'ES' },
                { code: 'GO', name: 'GO' },
                { code: 'MA', name: 'MA' },
                { code: 'MT', name: 'MT' },
                { code: 'MS', name: 'MS' },
                { code: 'MG', name: 'MG' },
                { code: 'PA', name: 'PA' },
                { code: 'PB', name: 'PB' },
                { code: 'PR', name: 'PR' },
                { code: 'PE', name: 'PE' },
                { code: 'PI', name: 'PI' },
                { code: 'RJ', name: 'RJ' },
                { code: 'RN', name: 'RN' },
                { code: 'RO', name: 'RO' },
                { code: 'RS', name: 'RS' },
                { code: 'RR', name: 'RR' },
                { code: 'SC', name: 'SC' },
                { code: 'SE', name: 'SE' },
                { code: 'SP', name: 'SP' },
                { code: 'TO', name: 'TO' }
            ]
        }),
        mounted() {

        },
        computed: {
        },
        methods: {
            searchCep() {
                var self = this;
                if (self.paymentBankInvoice.postalCode.length >= 8) {
                    cepApi.getAddress({ cep: self.paymentBankInvoice.postalCode })
                        .then(function (data) {
                            self.paymentBankInvoice.addressStreet = data.logradouro;
                            self.paymentBankInvoice.addressCity = data.localidade;
                            self.paymentBankInvoice.addressState = data.uf;
                            self.paymentBankInvoice.addressNeighborhood = data.bairro;
                        });
                }
            }
        }
    }
</script>

